module.exports = __webpack_public_path__ + "img/safr-logo-colour.9b98e799.png";